import { Component, Input } from '@angular/core';
import { BehaviorSubject, iif, of } from 'rxjs';
import { map, switchMap, tap } from 'rxjs/operators';
import { PriceListService } from '../../../shared/services/price-list.service';
import { CustomerPriceListItem } from '../../../models/price-lists';
import { CUSTOMER } from 'src/testIds';
import {
  MatTable,
  MatTableDataSource,
  MatTableModule
} from '@angular/material/table';
import { TestIdDirective } from 'src/app/shared/directives/test-id.directive';
import { RouterLink } from '@angular/router';
import { PricesDisplayComponent } from 'src/app/shared/product-price-display/prices-display.component';
import { AsyncPipe, NgIf } from '@angular/common';

@Component({
  selector: 'app-customers-prices-tab',
  templateUrl: './customers-prices-tab.component.html',
  providers: [PriceListService],
  standalone: true,
  imports: [
    MatTableModule,
    TestIdDirective,
    RouterLink,
    PricesDisplayComponent,
    AsyncPipe,
    NgIf
  ]
})
export class CustomersPricesTabComponent {
  @Input() set customerId(value: number) {
    this._customerId.next(value);
  }

  private _customerId = new BehaviorSubject<number>(null);
  prices$ = this._customerId.asObservable().pipe(
    switchMap((customerId: number) =>
      iif(
        () => customerId === null,
        of([]),
        this.priceListService
          .getByCustomerId(customerId)
          .pipe(
            map((prices) =>
              prices.sort((a, b) =>
                a.product_name.localeCompare(b.product_name)
              )
            )
          )
      )
    ),
    tap(
      (prices: CustomerPriceListItem[]) =>
        (this.showPricesTable = prices.length > 0)
    )
  );
  displayedColumns = ['product', 'prices'];
  showPricesTable = true;
  testIds = CUSTOMER;

  constructor(private priceListService: PriceListService) {}
}
